import { configureStore } from '@reduxjs/toolkit';

import { persistReducer, persistStore } from 'redux-persist';
import { setupListeners } from '@reduxjs/toolkit/dist/query';
import { RootReducer } from 'features';
import storage from 'redux-persist/lib/storage';
import { apiServices } from 'services/RtkServices';

const persistConfig = {
  key: 'root',
  storage: storage,
  whitelist: ['auth']
};

const persistedReducer = persistReducer(persistConfig, RootReducer);
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(apiServices.middleware)
});

setupListeners(store.dispatch);
export const persistor = persistStore(store);
